import { ResponseMessage } from "../clients/response-message";

export class WebApiError extends Error {
    readonly name: string = "WebApiError";

    /**
     * The HTTP response status code.
     */
    readonly statusCode: number;

    /**
     * The response message.
     */
    readonly responseMessage: ResponseMessage;

    constructor(message: string, statusCode: number, responseMessage: ResponseMessage) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);

        this.statusCode = statusCode;
        this.responseMessage = responseMessage;
    }
}
